import {Typography} from "@mui/material";

export const EndUserLicenseAgreement: React.FC = () => (
    <Typography fontSize={14}>
        <p>
            <strong>HYDROSAT TERMS OF SERVICE</strong>
        </p>
        <p>
            <em>Last Updated</em>: 15/11/2024
        </p>
        <p>
            Please read these Terms of Service (the “Agreement”) carefully. Your use of the Site (as defined below)
            constitutes your consent to this Agreement.
        </p>
        <p>
            This Agreement is between you and Hydrosat Inc., and its subsidiaries and affiliates (“Company” or “we” or
            “us”) concerning your use of (including any access to) the site currently located at{" "}
            <a href="http://www.hydrosat.com/" className="uri">
                http://www.hydrosat.com/
            </a>{" "}
            (together with any materials and services available therein, and successor site(s) thereto, the “Site”).
            References to “you” and “your” in this Agreement will refer to both the individual using the Site and to any
            such Organization (as defined below). This Agreement hereby incorporates by this reference any additional
            terms and conditions posted by Company through the Site, or otherwise made available to you by Company.
            Additionally, your use of the Site, and each Subscription (as defined below), is at all times governed by
            and subject to the Order Form and Subscription Agreement between you and Company (collectively the
            “Subscription Agreement”). In the event of a conflict between the terms of this Agreement and the terms of
            any Subscription Agreement, the Subscription Agreement shall control and supersede.
        </p>
        <p>
            THESE TERMS APPLY TO YOUR ACCESS AND USE OF THE SITE, ALL OTHER WEBSITES, MOBILE SITES, SERVICES,
            APPLICATIONS, PLATFORMS AND OTHER TOOLS WHERE THESE TERMS APPEAR OR ARE OTHERWISE REFERENCED, OR FOR WHICH
            NO SEPARATE TERMS ARE PROVIDED AS WELL AS TO YOUR VISITS TO OR INTERACTION WITH US ON OUR SITE OR ELSEWHERE.
        </p>
        <p>
            BY USING THE SITE, YOU AFFIRM THAT YOU ARE OF LEGAL AGE TO ENTER INTO THIS AGREEMENT, AND THAT YOU
            UNCONDITIONALLY AGREE TO BE BOUND BY AND SUBJECT TO THIS AGREEMENT.
        </p>
        <p>
            IF YOU ARE AN INDIVIDUAL ACCESSING OR USING THE SITE ON BEHALF OF, OR FOR THE BENEFIT OF, ANY CORPORATION,
            PARTNERSHIP OR OTHER ENTITY WITH WHICH YOU ARE ASSOCIATED (AN “ORGANIZATION”), THEN YOU ARE AGREEING TO THIS
            AGREEMENT ON BEHALF OF YOURSELF AND SUCH ORGANIZATION, AND YOU REPRESENT AND WARRANT THAT YOU HAVE THE LEGAL
            AUTHORITY TO BIND SUCH ORGANIZATION TO THIS AGREEMENT.
        </p>
        <p>
            THIS AGREEMENT CONTAINS A MANDATORY ARBITRATION PROVISION THAT, AS FURTHER SET FORTH BELOW, REQUIRES THE USE
            OF ARBITRATION ON AN INDIVIDUAL BASIS TO RESOLVE DISPUTES, RATHER THAN JURY TRIALS OR ANY OTHER COURT
            PROCEEDINGS, OR CLASS ACTIONS OF ANY KIND. BY USING or ACCESSING THE SITE YOU ARE ENTERING INTO THIS
            AGREEMENT, AND YOU EXPRESSLY ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND ALL OF THE TERMS OF THIS MUTUAL
            ARBITRATION AGREEMENT AND HAVE TAKEN THE TIME TO CONSIDER THE CONSEQUENCES OF THIS IMPORTANT DECISION. THIS
            agreemenT ALSO CONTAIN RELEASES, LIMITATIONS ON LIABILITY, AND PROVISIONS ON INDEMNITY, ALL OF WHICH MAY
            LIMIT YOUR LEGAL RIGHTS AND REMEDIES.
        </p>
        <p>
            We reserve the right to refuse service, terminate accounts, remove or edit content, or cancel Subscriptions
            in our sole discretion.
        </p>
        <p>
            We reserve the right to withdraw or amend this Site, and any service or material we provide on the Site, at
            our sole discretion without notice. We will not be liable if for any reason all or any part of the Site is
            unavailable at any time or for any period. From time to time, we may restrict access to some parts of the
            Site, or the entire Site, to anyone. We also reserve the right to disable any account, username, password,
            or other identifier, whether chosen by you or provided by us, at any time in our sole discretion for any or
            no reason, including if, in our opinion, you have violated any provision of this Agreement.
        </p>
        <p>
            <strong>INTELLECTUAL PROPERTY.</strong> The Site, including all of its information and contents such as
            photographs, images, text, data, wallpapers, icons, characters, artwork, graphics, page layout, form, music,
            sound, video, messages, software and the code used to generate the pages on the Site (collectively, the
            “Materials”), is the property of Company or that of our authorized suppliers or licensors, and is protected
            by intellectual property and other applicable laws in the United States and/or abroad. Our intellectual
            property is registered in the United States and abroad. Except as otherwise provided on the Site or in these
            Terms, you may not download, upload, copy, print, display, reproduce, publish, license, post, distribute, or
            otherwise use any Materials from the Site in whole or in part for any public or commercial purpose without
            our specific prior written permission. We are the owner and/or authorized user of the Company brand as well
            as any other registered or unregistered trademarks, trade names, logos, designs, titles and product names
            appearing on the Site, and is the copyright owner or licensee of the Materials on the Site, unless otherwise
            indicated. You may not use any metatags or any other “hidden text” utilizing any of our names or trademarks
            without our express written consent.
        </p>
        <p>
            You agree not to infringe any or all of the title, ownership and intellectual property rights of Company or
            any third parties. You hereby agree to indemnify and hold us harmless in the event of any claims of breach
            of intellectual property rights by or through your use of the Site and any content contained therein (or
            other material as set forth above). All rights not otherwise claimed under these Terms or by us are hereby
            reserved.
        </p>
        <p>
            <strong>USER GENERATED CONTENT.</strong> The Site may allow you to upload, submit, store, send, or receive
            content and data such as photos, video, text, data, and comments (“User Generated Content”). You may also
            submit User Generated Content in the other ways that you interact with Us such as through social media, by
            email, by phone, and otherwise. You are solely responsible for your own User-Generated Content and the
            consequences of posting or publishing it to the Site. We do not endorse any User-Generated Content or any
            opinion or recommendation expressed therein. We may refuse to accept or transmit User Generated Content for
            any reason with or without notice. We may remove User Generated Content from the Site for any reason with or
            without notice.
        </p>
        <p>
            When you upload, post, submit, send, or receive any User Generated Content to or through the Site, you give
            us a perpetual, worldwide, non-exclusive, irrevocable, fully-paid, royalty-free, fully sub-licensable
            (through multiple tiers) and transferable right and license to use, reproduce, distribute, edit, modify,
            translate, reformat, prepare derivative works based upon, display publicly, perform publicly and otherwise
            exploit (including but not limited to over the Internet, broadcast television or any other uses or media)
            your User Generated Content, in whole or in part, including future rights that we (including any successor)
            may otherwise become entitled to that do not yet exist, as well as new uses, media, means and forms of
            exploitation throughout the universe exploiting current or future technology yet to be developed. You grant
            us and sublicensees the right to use the name that you submit in connection with such User-Generated
            Content, if they choose.
        </p>
        <p>You further promise, warrant and represent that:</p>
        <ul>
            <li>
                <p>
                    you own all rights to your User Generated Content or, alternatively, that you have the right to give
                    us the rights described above;
                </p>
            </li>
            <li>
                <p>
                    your User Generated Content shall not contain or constitute viruses, political campaigning,
                    commercial solicitation, affiliate links, chain letters, mass mailings or any form of “spam”;
                </p>
            </li>
            <li>
                <p>
                    your User Generated Content shall not be illegal, obscene, threatening, defamatory, constitute an
                    invasive of privacy or infringement of any intellectual property rights, or otherwise be
                    objectionable or injurious to third parties;
                </p>
            </li>
            <li>
                <p>
                    your User Generated Content does not infringe the intellectual property rights, privacy rights,
                    publicity rights, or other legal rights of any third party; and
                </p>
            </li>
            <li>
                <p>
                    You shall not use a false email address or identity, or impersonate any person, or otherwise mislead
                    us as to the source, origin, author or submitter of any User Generated Content.
                </p>
            </li>
        </ul>
        <p>
            We have the right, but not the obligation, to monitor and edit or remove any activity or User Generated
            Content. We take no responsibility and assume no liability for any User Generated Content. By posting User
            Generated Content, you agree to indemnify us for all losses resulting from any claims related to or arising
            out of the User Generated Content that you supply, as further explained under the section below titled
            “Indemnity”.
        </p>
        <p>
            You also agree further that we are not responsible and shall have no liability to you for any User Generated
            Content posted by others, including defamatory, offensive or illicit material and that the risk of damages
            from such material or content rests entirely with you.
        </p>
        <p>
            <strong>YOUR ACCOUNT.</strong> You may be required to register with us in order to access certain services
            or areas of the Site. If you create an account, your username and password are for your personal use only
            and you are responsible for maintaining the confidentiality of your account information (including your
            password) and for restricting access to your account. You agree to accept responsibility for all activities
            that occur under your account or password. In addition to all other rights available, We reserve the right,
            in our sole discretion, to terminate your account, refuse service to you, or cancel orders.
        </p>
        <p>
            <strong>ELECTRONIC COMMUNICATIONS.</strong> When visiting the Site, or when you send us emails, you are
            communicating with us electronically. By using the Site, you consent to receive communications from us
            electronically. We may communicate with you by email or by posting notices on the Site. You agree that all
            agreements, notices, disclosures and other communications that we provide to you electronically will satisfy
            any legal requirement that such communications be in writing.
        </p>
        <p>
            <strong>YOUR USE OF THE SITE.</strong> We grant you a limited, non-exclusive, nontransferable license to
            access and make use of the Site and the Materials only for your internal business purposes conducted in the
            ordinary course of your business. This license does not include any resale or commercial use of the Site or
            Materials; any collection and commercial use of the Site or Materials; any derivative use of the Site or
            Materials; any downloading, copying, or other use of the Site or Materials for the benefit of any third
            party; or any use of data mining, robots, or similar data gathering and extraction tools. You may use the
            Site and Materials only as permitted by law. All rights not expressly granted to you in these Terms are
            reserved and retained by us and/or our suppliers and licensors. The licenses granted by us to you
            automatically terminate if you do not comply with these Terms.
        </p>
        <p>
            You agree to use the Site and Materials for your internal business purposes conducted in the ordinary course
            of your business only and shall in no event use any of the Materials obtained on or through the Site for
            commercial purposes of any sort, nor for copying, reproducing, downloading, compiling whether directly,
            indirectly. Use of any Materials on the Site for purposes other than as permitted in these Terms is
            prohibited.
        </p>
        <p>
            <strong>SYSTEM USE NOTIFICATION.</strong> By accessing and using this Site, you are entering a system owned
            and operated by Hydrosat Inc. Unauthorized use of this system is prohibited and may result in criminal,
            civil, or administrative penalties. Access to this system is strictly limited to authorized users. Any
            attempt to access or use this system without proper authorization is unlawful.
        </p>
        <p>
            All activities on this system may be monitored and recorded for operational, security, and legal purposes.
            By continuing to use this system, you acknowledge and consent to such monitoring. If unauthorized use or
            security breaches are detected, Hydrosat Inc. reserves the right to take immediate action, including
            terminating your access or reporting incidents to the appropriate authorities.
        </p>
        <p>
            Any misuse or tampering with the system, including attempts to access restricted areas or introduce
            malicious software, is prohibited. Unauthorized actions may lead to disciplinary action, termination of
            access, and potential legal prosecution under applicable law.
        </p>
        <p>
            <strong>CHANGES.</strong> We may change this Agreement from time to time by notifying you of such changes by
            any reasonable means, including by posting a revised Agreement through the Site. Any such changes will not
            apply to any dispute between you and us arising prior to the date on which we posted the revised Agreement
            incorporating such changes, or otherwise notified you of such changes.
        </p>
        <p>
            Your use of the Site following any changes to this Agreement will constitute your acceptance of such
            changes. The “<em>Last Updated</em>” legend above indicates when this Agreement was last changed. We may, at
            any time and without liability, modify or discontinue all or part of the Site (including access to the Site
            via any third-party links); charge, modify or waive any fees required to use the Site; or offer
            opportunities to some or all Site users.
        </p>
        <p>
            <strong>PRIVACY POLICY &amp; INFORMATION SUBMITTED THROUGH THE SITE</strong>. Your submission of information
            through the Site is governed by Company’s Privacy Policy, located at{" "}
            <a href="http://www.hydrosat.com/privacy" className="uri">
                http://www.hydrosat.com/privacy
            </a>{" "}
            (the “Privacy Policy”). You represent and warrant that any information you provide in connection with the
            Site is and will remain accurate and complete, and that you will maintain and update such information as
            needed.
        </p>
        <p>
            Please review our Privacy Policy, which also governs your use of the Site, to understand how we collect,
            use, disclose, and secure personal information, as well as any rights that you may have.
        </p>
        <p>
            <strong>JURISDICTIONAL ISSUES</strong>. The Site is controlled and operated from the United States and all
            customer data is stored and processed in the United States. The Site is not intended to subject the Company
            to any non-U.S. jurisdiction or law, or, unless your Subscription Agreement provides otherwise, for visitors
            or users outside the United States. The Site may not be appropriate, available, or lawful for use in some
            non-U.S. jurisdictions. Also, we may transfer your data from the U.S. to other countries or regions in
            connection with storage and processing of data, fulfilling your requests, and operating the Site. By
            providing any information, including personal information, on or to the Site, you consent to such transfer,
            storage, and processing. Any use of the Site is at your own risk, and you must comply with all applicable
            laws, rules and regulations in doing so. We may limit the Site’s availability at any time, in whole or in
            part, to any person, geographic area or jurisdiction that we choose.
        </p>
        <p>
            <strong>RULES OF CONDUCT</strong>. In connection with the Site, you must not:
        </p>
        <ul>
            <li>
                <p>
                    Post, transmit or otherwise make available through or in connection with the Site any content that
                    is or may be: (a) threatening, harassing, degrading, hateful or intimidating, or otherwise fail to
                    respect the rights and dignity of others; (b) defamatory, libelous, fraudulent or otherwise
                    tortious; (c) obscene, indecent, pornographic or otherwise objectionable; or (d) protected by
                    copyright, trademark, trade secret, right of publicity or privacy or any other proprietary right,
                    without the express prior written consent of the applicable owner.
                </p>
            </li>
            <li>
                <p>
                    Post, transmit or otherwise make available through or in connection with the Site any virus, worm,
                    Trojan horse, Easter egg, time bomb, spyware or other computer code, file or program that is or is
                    potentially harmful or invasive or intended to damage or hijack the operation of, or to monitor the
                    use of, any hardware, software or equipment (each, a “Virus”).
                </p>
            </li>
            <li>
                <p>
                    Other than for your internal business purposes conducted in the ordinary course of your business,
                    use the Site for any commercial purpose, or for any purpose that is fraudulent or otherwise tortious
                    or unlawful.
                </p>
            </li>
            <li>
                <p>
                    Use the Site in a manner, or make any Submission to the Site, that infringes upon any intellectual
                    property right of any third party;
                </p>
            </li>
            <li>
                <p>
                    Use the Site in any manner that violates any applicable federal, state, local or international law
                    or regulation (including, without limitation, any laws regarding the export of data or software to
                    and from the U.S. or other countries).
                </p>
            </li>
            <li>
                <p>Harvest or collect information about users of the Site.</p>
            </li>
            <li>
                <p>
                    Impersonate or attempt to impersonate Company, an employee or agent of Company, another user or any
                    other person or entity, including, without limitation, by using email addresses, telephone numbers,
                    or screen names associated with any of the foregoing, or otherwise submitting false information.
                </p>
            </li>
            <li>
                <p>
                    Interfere with or disrupt the operation of the Site or the servers or networks used to make the Site
                    available, including by hacking or defacing any portion of the Site; or violate any requirement,
                    procedure or policy of such servers or networks.
                </p>
            </li>
            <li>
                <p>
                    Use the Site in any manner that could disable, overburden, damage, or impair the Site or interfere
                    with any other party’s use of the Site, including their ability to engage in real time activities
                    through the Site.
                </p>
            </li>
            <li>
                <p>Restrict or inhibit any other person from using the Site.</p>
            </li>
            <li>
                <p>Use any device, software or routine that interferes with the proper working of the Site.</p>
            </li>
            <li>
                <p>
                    Attempt to gain unauthorized access to, interfere with, damage or disrupt any parts of the Site, the
                    server on which the Site is stored, or any server, computer or database connected to the Site.
                </p>
            </li>
            <li>
                <p>
                    Attempt to gain unauthorized access to any personal information that may be contained on the Site,
                    the server on which the Site is stored, or any server, computer, database or information system
                    connected to the Site.
                </p>
            </li>
            <li>
                <p>Collect, store or use personal information about other users of the Site without their consent.</p>
            </li>
            <li>
                <p>
                    Attempt to circumvent any technological measure implemented by us or any of our providers or any
                    other third party (including another user) to protect the Site.
                </p>
            </li>
            <li>
                <p>
                    Reproduce, modify, adapt, translate, create derivative works of, sell, rent, lease, loan, timeshare,
                    distribute or otherwise exploit any portion of (or any use of) the Site except as expressly
                    authorized herein, without Company’s express prior written consent.
                </p>
            </li>
            <li>
                <p>
                    Reverse engineer, decompile or disassemble any portion of the Site, except where such restriction is
                    expressly prohibited by applicable law.
                </p>
            </li>
            <li>
                <p>Remove any copyright, trademark or other proprietary rights notice from the Site.</p>
            </li>
            <li>
                <p>
                    Frame or mirror any portion of the Site, or otherwise incorporate any portion of the Site into any
                    product or service, without Company’s express prior written consent.
                </p>
            </li>
            <li>
                <p>Systematically download and store Site content.</p>
            </li>
            <li>
                <p>
                    Use any robot, spider, site search/retrieval application or other manual or automatic device to
                    retrieve, index, “scrape,” “data mine” or otherwise gather Site content, or reproduce or circumvent
                    the navigational structure or presentation of the Site, without Company’s express prior written
                    consent. Notwithstanding the foregoing, and subject to compliance with any instructions posted in
                    the robots.txt file located in the Site’s root directory, Company grants to the operators of public
                    search engines permission to use spiders to copy content from the Site for the sole purpose of (and
                    solely to the extent necessary for) creating publicly available, searchable indices of such content,
                    but not caches or archives of such content. Company reserves the right to revoke such permission
                    either generally or in specific cases, at any time and without notice.
                </p>
            </li>
            <li>
                <p>Advocate, encourage, or assist any third party in doing any of the foregoing.</p>
            </li>
        </ul>
        <p>
            <strong>YOUR EQUIPMENT &amp; TECHNOLOGY.</strong> You are responsible for obtaining, maintaining and paying
            for all hardware and all telecommunications and other services you need to use the Site.
        </p>
        <p>
            <strong>PAYMENT TRANSACTIONS.</strong> Subscriptions to the Site are available to purchase online through
            the Site (each a “Transaction”). If you submit an Order Form for a Subscription to the Site, you may be
            asked to supply certain relevant information, such as your credit card or other approved payment method
            account number, expiration date, security code, or billing address.{" "}
            <strong>
                YOU REPRESENT AND WARRANT THAT YOU HAVE THE RIGHT TO USE ANY CREDIT CARD THAT YOU SUBMIT IN CONNECTION
                WITH A TRANSACTION.
            </strong>
            By submitting such information, you grant to us the right to provide such information to third parties for
            purposes of facilitating Transactions. Verification of information may be required prior to the
            acknowledgment or completion of any Transaction. By making a Transaction, you represent that the
            Subscription you purchase will be used only in a lawful manner. Company reserves the right, including
            without prior notice, to limit the availability of or discontinue making available any product; to impose
            conditions on the honoring of any coupon, discount or similar promotion; to bar any user from making any
            Transaction; and to refuse to provide any user with any product. You agree to pay all charges incurred by
            you or on your behalf through the Site, at the prices in effect when such charges are incurred, including
            all shipping and handling charges. In addition, you are responsible for any taxes applicable to your
            Transactions. While it is our practice to confirm orders by e-mail, the receipt of an e-mail order
            confirmation does not constitute our acceptance of an order or our confirmation of an offer to sell a
            product or service.
        </p>
        <p>
            <strong>SUBSCRIPTIONS.</strong> Access to some sections, features, or content on the Site is granted and
            billed on a subscription basis (“Subscription(s)”). For such access, you will be billed in advance on a
            recurring and periodic basis (“Billing Cycle”). Billing Cycles are set either on a monthly, quarterly or
            annual basis, depending on the types of subscription plan we offer for particular services and the type of
            subscription plan you select when purchasing a Subscription.
        </p>
        <p>
            At the end of each Billing Cycle, your Subscription will automatically renew unless you cancel it pursuant
            to the terms of your Order Form and Subscription Agreement, or we cancel it. You may cancel your
            Subscription renewal either through your online account management page or by contacting our customer
            support team.
        </p>
        <p>
            A valid payment method, such as credit card account or ACH payment authorization, is required to process the
            payment for your Subscription. You shall provide us with accurate and complete billing information including
            full name, address, state, zip code, telephone number, and a valid payment method information. By submitting
            such payment information, you automatically authorize us to charge all Subscription fees incurred through
            your account to any such payment instruments.
        </p>
        <p>
            Should automatic billing fail to occur for any reason, we will issue an electronic invoice indicating that
            you must proceed manually, within a certain deadline date, with the full payment corresponding to the
            billing period as indicated on the invoice.
        </p>
        <p>
            <strong>REGISTRATION; USERNAMES AND PASSWORDS</strong>. You may need to register to use all or part of the
            Site. We may reject, or require that you change, any username, password or other information that you
            provide to us in registering. Your username and password are for your personal use only and should be kept
            confidential; you, and not Company, are responsible for any use or misuse of your username or password, and
            you must promptly notify us of any confidentiality breach or unauthorized use of your username or password,
            or your Site account.{" "}
            <strong>
                In the event of a confidentiality breach or unauthorized use of your username or password, or if you
                have any security concerns regarding the Site, please email us at
            </strong>{" "}
            <a href="mailto:security@hydrosat.com">
                <strong>security@hydrosat.com</strong>
            </a>
            <strong>.</strong>
        </p>
        <p>
            <strong>PROFILES AND FORUMS</strong>. Site visitors may make available certain content (each, a
            “Submission”) through or in connection with the Site, including on profile pages or on the Site’s
            interactive services, such as message boards and other forums, and chatting, commenting and other messaging
            functionality. Company has no control over and is not responsible for any use or misuse (including any
            distribution) by any third party of Submissions. IF YOU CHOOSE TO MAKE ANY OF YOUR PERSONALLY IDENTIFIABLE
            OR OTHER INFORMATION PUBLICLY AVAILABLE THROUGH THE SITE, YOU DO SO AT YOUR OWN RISK.
        </p>
        <p>
            <strong>LICENSE.</strong> For each Submission, you hereby grant to us a worldwide, royalty-free, fully
            paid-up, non-exclusive, perpetual, irrevocable, transferable and fully sublicensable (through multiple
            tiers) license, without additional consideration to you or any third party, to reproduce, distribute,
            perform and display (publicly or otherwise), create derivative works of, adapt, modify and otherwise use,
            analyze and exploit such Submission, in any format or media now known or hereafter developed, and for any
            purpose (including promotional purposes, such as testimonials).
        </p>
        <p>
            In addition, if you provide to us any ideas, proposals, suggestions or other content (“Feedback”), whether
            related to the Site or otherwise, such Feedback will be deemed a Submission, and you hereby acknowledge and
            agree that such Feedback is not confidential, and that your provision of such Feedback is gratuitous,
            unsolicited and without restriction, and does not place Company under any fiduciary or other obligation.
        </p>
        <p>
            You represent and warrant that you have all rights necessary to grant the licenses granted in this section,
            and that your Submissions, and your provision thereof through and in connection with the Site, are complete
            and accurate, and are not fraudulent, tortious or otherwise in violation of any applicable law or any right
            of any third party. You further irrevocably waive any “moral rights” or other rights with respect to
            attribution of authorship or integrity of content regarding each Submission that you may have under any
            applicable law under any legal theory.
        </p>
        <p>
            <strong>MONITORING.</strong> We may (but have no obligation to) monitor, evaluate, alter or remove
            Submissions before or after they appear on the Site, or analyze your access to or use of the Site. We may
            disclose information regarding your access to and use of the Site, and the circumstances surrounding such
            access and use, to anyone for any reason or purpose.
        </p>
        <p>
            <strong>USE OF SOCIAL MEDIA TAGS</strong>. When you use social media tags (such as on Instagram, Facebook,
            TikTok, LinkedIn, YouTube or X) that identify or are associated with us, including without limitation{" "}
            <span className="citation" data-cites="hydrosat">
                @hydrosat
            </span>
            ,{" "}
            <span className="citation" data-cites="hydrosatI">
                @hydrosatI
            </span>{" "}
            #hydrosat,{" "}
            <span className="citation" data-cites="irriwatch">
                @irriwatch
            </span>
            , #irriwatch or any other similar social media tag in any way related to us, you agree to provide us with an
            unrestricted, irrevocable, non-exclusive, royalty-free, perpetual, fully paid-up, transferable, worldwide
            license to reproduce and use the uploaded content, including image(s), in our (or our sublicensees’)
            marketing materials and through all social media channels.
        </p>
        <p>
            <strong>THIRD PARTY MATERIALS, LINKS</strong>. Certain Site functionality may make available access to
            information, products, services and other content made available by third parties, including Submissions
            (“Third Party Materials”), or allow for the routing or transmission of such Third Party Materials, including
            via links. By using such functionality, you are directing us to access, route and transmit to you the
            applicable Third Party Materials.
        </p>
        <p>
            We neither control nor endorse, nor are we responsible for, any Third Party Materials, including the
            accuracy, validity, timeliness, completeness, reliability, integrity, quality, legality, usefulness or
            safety of Third Party Materials, or any intellectual property rights therein. Certain Third Party Materials
            may, among other things, be inaccurate, misleading or deceptive. Nothing in this Agreement shall be deemed
            to be a representation or warranty by Company with respect to any Third Party Materials. We have no
            obligation to monitor Third Party Materials, and we may block or disable access to any Third Party Materials
            (in whole or part) through the Site at any time. In addition, the availability of any Third Party Materials
            through the Site does not imply our endorsement of, or our affiliation with, any provider of such Third
            Party Materials, nor does such availability create any legal relationship between you and any such provider.
        </p>
        <p>
            YOUR USE OF THIRD PARTY MATERIALS IS AT YOUR OWN RISK AND IS SUBJECT TO ANY ADDITIONAL TERMS, CONDITIONS AND
            POLICIES APPLICABLE TO SUCH THIRD PARTY MATERIALS (SUCH AS TERMS OF SERVICE OR PRIVACY POLICIES OF THE
            PROVIDERS OF SUCH THIRD PARTY MATERIALS).
        </p>
        <p>
            <strong>DISCLAIMER OF WARRANTIES</strong>. TO THE FULLEST EXTENT PERMITTED UNDER APPLICABLE LAW: (A) THE
            SITE, MATERIALS AND ANY PRODUCTS OR THIRD PARTY MATERIALS ARE MADE AVAILABLE TO YOU ON AN “AS IS,” “WHERE
            IS” AND “WHERE AVAILABLE” BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED OR STATUTORY;
            AND (B) COMPANY DISCLAIMS ALL WARRANTIES WITH RESPECT TO THE SITE , MATERIALS, PRODUCTS AND THIRD PARTY
            MATERIALS, INCLUDING THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT
            AND TITLE. ALL DISCLAIMERS OF ANY KIND (INCLUDING IN THIS SECTION AND ELSEWHERE IN THIS AGREEMENT) ARE MADE
            FOR THE BENEFIT OFBOTH COMPANY AND ITS AFFILIATES AND THEIR RESPECTIVE SHAREHOLDERS, DIRECTORS, OFFICERS,
            EMPLOYEES, AFFILIATES, AGENTS, REPRESENTATIVES, LICENSORS, SUPPLIERS AND SERVICE PROVIDERS (COLLECTIVELY,
            THE “AFFILIATED ENTITIES”), AND THEIR RESPECTIVE SUCCESSORS AND ASSIGNS.
        </p>
        <p>
            <strong>INACCURACY DISCLAIMER.</strong> While we try to maintain the timeliness, integrity and security of
            the Site, we do not guarantee that the Site is or will remain updated, complete, correct or secure, or that
            access to the Site will be uninterrupted. The Site may include inaccuracies, errors and content that violate
            or conflict with this Agreement. If you become aware of any such inaccuracy or erroneous content, please
            contact us at{" "}
            <a href="mailto:support@hydrosat.com" className="email">
                support@hydrosat.com
            </a>{" "}
            with a description of the content and its location on the Site.
        </p>
        <p>
            <strong>OUTAGES.</strong> We periodically schedule system downtime for the Site for maintenance and other
            purposes. Unplanned system outages also may occur. You agree that We have no responsibility and are not
            liable for: (a) the unavailability of any part of the Site; (b) any loss of data, information or materials
            caused by such system outages; (c) the resultant delay, mis-delivery or non-delivery of data, information or
            materials caused by such system outages; or (d) any outages caused by any third parties, including without
            limitation any companies or servers hosting the Sites, any Internet service providers or otherwise.
        </p>
        <p>
            <strong>RELIANCE ON INFORMATION POSTED.</strong> The information presented on or through the Site is made
            available solely for general information purposes. We do not warrant the accuracy, completeness or
            usefulness of this information. Any reliance you place on such information is strictly at your own risk. We
            disclaim all liability and responsibility arising from any reliance placed on such materials by you or any
            other visitor to the Site, or by anyone who may be informed of any of its contents. This Site may include
            content provided by third parties, including materials provided by other users (see User Generated Content),
            third-party licensors, syndicators, aggregators and/or reporting services. All statements and/or opinions
            expressed in these materials, and all articles and responses to questions and other content, other than the
            content provided by Us, are solely the opinions and the responsibility of the person or entity providing
            those materials. These materials do not necessarily reflect our opinion. We are not responsible, or liable
            to you or any third party, for the content or accuracy of any materials provided by any third parties.
        </p>
        <p>
            <strong>LIMITATION OF LIABILIT</strong>Y<strong>.</strong>TO THE FULLEST EXTENT PERMITTED UNDER APPLICABLE
            LAW: (A) COMPANY WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY OR
            PUNITIVE DAMAGES OF ANY KIND, UNDER ANY CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY OR OTHER
            THEORY, INCLUDING DAMAGES FOR LOSS OF PROFITS, USE OR DATA, LOSS OF OTHER INTANGIBLES, LOSS OF SECURITY OF
            SUBMISSIONS (INCLUDING UNAUTHORIZED INTERCEPTION BY THIRD PARTIES OF ANY SUBMISSIONS), EVEN IF ADVISED IN
            ADVANCE OF THE POSSIBILITY OF SUCH DAMAGES OR LOSSES; (B) WITHOUT LIMITING THE FOREGOING, COMPANY WILL NOT
            BE LIABLE FOR DAMAGES OF ANY KIND RESULTING FROM YOUR USE OF OR INABILITY TO USE THE SITE OR FROM ANY
            PRODUCTS OR THIRD PARTY MATERIALS, INCLUDING FROM ANY VIRUS THAT MAY BE TRANSMITTED IN CONNECTION THEREWITH;
            (C) YOUR SOLE AND EXCLUSIVE REMEDY FOR DISSATISFACTION WITH THE SITE OR ANY PRODUCTS OR THIRD PARTY
            MATERIALS IS TO STOP USING THE SITE; AND (D) THE MAXIMUM AGGREGATE LIABILITY OF COMPANY FOR ALL DAMAGES,
            LOSSES AND CAUSES OF ACTION, WHETHER IN CONTRACT, TORT (INCLUDING NEGLIGENCE) OR OTHERWISE, SHALL BE THE
            TOTAL AMOUNT, IF ANY, PAID BY YOU TO COMPANY TO USE THE SITE. ALL LIMITATIONS OF LIABILITY OF ANY KIND
            (INCLUDING IN THIS SECTION AND ELSEWHERE IN THIS AGREEMENT) ARE MADE FOR THE BENEFIT OF BOTH COMPANY AND THE
            AFFILIATED ENTITIES, AND THEIR RESPECTIVE SUCCESSORS AND ASSIGNS.
        </p>
        <p>
            Some jurisdictions do not allow the exclusion of certain warranties or the limitation or exclusion of
            liability for damages. Accordingly, some of the above limitations and disclaimers may not apply to you. To
            the extent we may not, as a matter of applicable law, disclaim any warranty or limit our liability, the
            scope and duration of such warranty and the extent of our liability will be the minimum permitted under such
            law.
        </p>
        <p>
            <strong>INDEMNITY</strong>. To the fullest extent permitted under applicable law, you agree to defend,
            indemnify and hold harmless Company and the Affiliated Entities, and their respective successors and
            assigns, from and against all claims, liabilities, damages, judgments, awards, losses, costs, expenses and
            fees (including attorneys’ fees) arising out of or relating to (a) your use of, or activities in connection
            with, the Site (including all Submissions); (b) any violation or alleged violation of this Agreement by you,
            (c) your infringement of the intellectual property rights of any third party; (d) your violation of any
            rights of another user; and (e) your violation of any applicable law, rule or regulation. If we assume the
            defense of such a matter, you will reasonably cooperate with us in such defense.
        </p>
        <p>
            <strong>TERMINATION.</strong> This Agreement is effective until terminated. Company may terminate or suspend
            your use of the Site at any time and without prior notice, for any or no reason, including if Company
            believes that you have violated or acted inconsistently with the letter or spirit of this Agreement. Upon
            any such termination or suspension, your right to use the Site will immediately cease, and Company may,
            without liability to you or any third party, immediately deactivate or delete your username, password and
            account, and all associated content, without any obligation to provide any further access to such content.
            All provisions of this Agreement which, by their nature, are intended to survive, shall survive any
            expiration or termination of this Agreement.
        </p>
        <p>
            <strong>GOVERNING LAW; ARBITRATION.</strong> The terms of this Agreement are governed by the laws of the
            United States (including federal arbitration law) and the State of Delaware, U.S.A., without regard to its
            principles of conflicts of law, and regardless of your location.
        </p>
        <p>
            EXCEPT WITH RESPECT TO CLAIMS (A) ALLEGING INTELLECTUAL PROPERTY INFRINGEMENT, OR (B) SEEKING EQUITABLE
            RELIEF, YOU AND COMPANY MUTUALLY AGREE THAT ALL CLAIMS, DISPUTES OR CONTROVERSIES ARISING OUT OF YOUR
            RELATIONSHIP WITH THE COMPANY, THIS AGREEMENT, OR THE BREACH, TERMINATION, ENFORCEMENT, INTERPRETATION OR
            VALIDITY THEREOF, INCLUDING THE DETERMINATION OF THE SCOPE OR APPLICABILITY OF THE PROVISIONS IN THIS
            AGREEMENT TO ARBITRATE, SHALL BE RESOLVED EXCLUSIVELY BY FINAL AND BINDING ARBITRATION ADMINISTERED BY
            JAMS/ENDISPUTE PURSUANT TO ITS COMPREHENSIVE ARBITRATION RULES AND PROCEDURES AND IN ACCORDANCE WITH THE
            EXPEDITED PROCEDURES IN THOSE RULES AND SHALL BE HELD BEFORE A SOLE ARBITRATOR IN WASHINGTON D.C., AND YOU
            AND COMPANY AGREE TO THIS EXCLUSIVE VENUE AND FORUM FOR ARBITRATION. YOU AND COMPANY AGREE THAT THE
            ARBITRATION PROCEEDINGS WILL BE KEPT CONFIDENTIAL AND THAT THE EXISTENCE OF THE PROCEEDING AND ANY ELEMENT
            OF IT (INCLUDING, WITHOUT LIMITATION, ANY PLEADINGS, BRIEFS OR OTHER DOCUMENTS SUBMITTED OR EXCHANGED AND
            ANY TESTIMONY OR OTHER ORAL SUBMISSIONS AND AWARDS) WILL NOT BE DISCLOSED BEYOND THE ARBITRATION
            PROCEEDINGS, EXCEPT AS MAY LAWFULLY BE REQUIRED IN JUDICIAL PROCEEDINGS RELATING TO THE ARBITRATION, BY
            APPLICABLE DISCLOSURE RULES AND REGULATIONS OF SECURITIES REGULATORY AUTHORITIES OR OTHER GOVERNMENTAL
            AGENCIES, OR AS SPECIFICALLY PERMITTED BY STATE LAW. THE FEDERAL ARBITRATION ACT AND FEDERAL ARBITRATION LAW
            APPLY TO THIS AGREEMENT. HOWEVER, THE ARBITRATOR, AND NOT ANY FEDERAL, STATE, OR LOCAL COURT OR AGENCY,
            SHALL HAVE THE EXCLUSIVE AUTHORITY TO RESOLVE ANY DISPUTE RELATING TO THE INTERPRETATION, APPLICABILITY,
            ENFORCEABILITY, OR FORMATION OF THIS AGREEMENT INCLUDING, BUT NOT LIMITED TO, A CLAIM THAT ALL OR ANY PART
            OF THIS AGREEMENT IS VOID OR VOIDABLE. JUDGMENT ON AN ARBITRATION AWARD MAY BE ENTERED IN ANY COURT HAVING
            JURISDICTION. THE ARBITRATION PROVISIONS HEREIN SHALL NOT PRECLUDE EITHER YOU OR COMPANY FROM SEEKING
            PROVISIONAL REMEDIES IN AID OF ARBITRATION FROM A COURT OF APPROPRIATE JURISDICTION.
        </p>
        <p>
            YOU AGREE THAT ANY ARBITRATION UNDER THIS AGREEMENT WILL TAKE PLACE ON AN INDIVIDUAL BASIS; CLASS
            ARBITRATIONS AND CLASS ACTIONS ARE NOT PERMITTED AND YOU ARE AGREEING TO GIVE UP THE ABILITY TO PARTICIPATE
            IN A CLASS ACTION.
        </p>
        <p>
            <strong>INFORMATION OR COMPLAINTS.</strong> If you have a question or complaint regarding the Site, please
            send an e-mail to{" "}
            <a href="mailto:support@hydrosat.com" className="email">
                support@hydrosat.com
            </a>
            . You may also contact us by writing to Hydrosat Inc., Attn: Website Support, 1250 Connecticut Ave NW, Ste
            700-09, Washington, DC 20036. Please note that e-mail communications will not necessarily be secure;
            accordingly, you should not include credit card information or other sensitive information in your e-mail
            correspondence with us.
        </p>
        <p>
            <strong>COPYRIGHT INFRINGEMENT CLAIMS.</strong> The Digital Millennium Copyright Act of 1998 (the “DMCA”)
            provides recourse for copyright owners who believe that material appearing on the Internet infringes their
            rights under U.S. copyright law. If you believe in good faith that Materials available on the Site infringe
            your copyright, you (or your agent) may send to Company a written notice by mail or e-mail, requesting that
            Company remove such material or block access to it. If you believe in good faith that someone has wrongly
            filed a notice of copyright infringement against you, the DMCA permits you to send to Company a
            counter-notice. Notices and counter-notices must meet the then-current statutory requirements imposed by the
            DMCA. See{" "}
            <a href="http://www.copyright.gov/" className="uri">
                http://www.copyright.gov/
            </a>{" "}
            for details.
        </p>
        <p>
            Notices and counter-notices must be sent in writing to Company’s DMCA agent as follows: By mail to Hydrosat
            Inc., Attn: Copyright Notices, 1250 Connecticut Ave NW, Ste 700-09, Washington, DC 20036; or by e-mail to{" "}
            <a href="mailto:copyright@hydrosat.com" className="email">
                copyright@hydrosat.com
            </a>
            . The Company’s DMCA Agent may be contacted by phone at (202) 630-9980.
        </p>
        <p>
            For your complaint, notice or counter-notice to be valid under the DMCA, you must provide the following in
            writing:
        </p>
        <ol type="1">
            <li>
                <p>
                    An electronic or physical signature of a person authorized to act on behalf of the copyright owner;
                </p>
            </li>
            <li>
                <p>Identification of the copyrighted work that you claim has been infringed;</p>
            </li>
            <li>
                <p>
                    Identification of the material that is claimed to be infringing and where it is located on the
                    Service;
                </p>
            </li>
            <li>
                <p>
                    Information reasonably sufficient to permit Heroku to contact you, such as your address, telephone
                    number, and, e-mail address;
                </p>
            </li>
            <li>
                <p>
                    A statement that you have a good faith belief that use of the material in the manner complained of
                    is not authorized by the copyright owner, its agent, or law; and
                </p>
            </li>
            <li>
                <p>
                    A statement, made under penalty of perjury, that the above information is accurate, and that you are
                    the copyright owner or are authorized to act on behalf of the owner.
                </p>
            </li>
        </ol>
        <p>We suggest that you consult your legal advisor before filing a DMCA notice or counter-notice.</p>
        <p>
            <strong>EXPORT CONTROLS.</strong> You are responsible for complying with United States export controls and
            for any violation of such controls, including any United States embargoes or other federal rules and
            regulations restricting exports. You represent, warrant and covenant that you are not (a) located in, or a
            resident or a national of, any country subject to a U.S. government embargo or other restriction, or that
            has been designated by the U.S. government as a “terrorist supporting” country; or (b) on any of the U.S.
            government lists of restricted end users.
        </p>
        <p>
            <strong>MISCELLANEOUS.</strong> This Agreement does not, and shall not be construed to, create any
            partnership, joint venture, employer-employee, agency or franchisor-franchisee relationship between you and
            Company. Under no circumstances will we be held liable for any delay or failure in performance due in whole
            or in part to any acts of nature or other causes beyond our reasonable control. If any provision of this
            Agreement is found to be unlawful, void or for any reason unenforceable, that provision will be deemed
            severable from this Agreement and will not affect the validity and enforceability of any remaining
            provision. You may not assign, transfer or sublicense any or all of your rights or obligations under this
            Agreement without our express prior written consent. We may assign, transfer or sublicense any or all of our
            rights or obligations under this Agreement without restriction. No waiver by either party of any breach or
            default under this Agreement will be deemed to be a waiver of any preceding or subsequent breach or default.
            You agree that regardless of any statute or law to the contrary, any claim or cause of action arising out of
            or related to use of the Site or this Agreement must be filed within one (1) year after such claim or cause
            of action arose or be forever barred. Any heading, caption or section title contained herein is for
            convenience only, and in no way defines or explains any section or provision. All terms defined in the
            singular shall have the same meanings when used in the plural, where appropriate and unless otherwise
            specified. Any use of the term “including” or variations thereof in this Agreement shall be construed as if
            followed by the phrase “without limitation.” This Agreement, including any terms and conditions incorporated
            herein, is the entire agreement between you and Company relating to the subject matter hereof, and
            supersedes any and all prior or contemporaneous written or oral agreements or understandings between you and
            Company relating to such subject matter. Notices to you (including notices of changes to this Agreement) may
            be made via posting to the Site or by e-mail (including in each case via links), or by regular mail. Without
            limitation, a printed version of this Agreement and of any notice given in electronic form shall be
            admissible in judicial or administrative proceedings based upon or relating to this Agreement to the same
            extent and subject to the same conditions as other business documents and records originally generated and
            maintained in printed form. Company will not be responsible for any failure to fulfill any obligation due to
            any cause beyond its control.
        </p>
        <p>
            <strong>THIRD PARTY TERMS.</strong> The following terms and conditions apply with respect to certain Third
            Party Materials, to the extent set forth below:
        </p>
        <p>
            <strong>Open Source.</strong> The Site may also include other open source components, which are licensed for
            use and distribution under applicable open source licenses. Use of any open source components is governed by
            and subject to the terms and conditions of the applicable open source license.
        </p>
        <p>
            <strong>ACCESSIBILITY.</strong> We strive to make our Site content accessible and user-friendly. If you are
            having difficulty viewing the content on this Site or navigating the site, please contact us{" "}
            <a href="mailto:support@hydrosat.com" className="email">
                support@hydrosat.com
            </a>
            , and we will be happy to assist you.
        </p>
        <p>
            <strong>VIOLATIONS.</strong> Please report any violations of these Terms to Us at{" "}
            <a href="mailto:support@hydrosat.com" className="email">
                support@hydrosat.com
            </a>
            .
        </p>
        <p>
            <strong>QUESTIONS?</strong> If you have questions, comments or complaints about these Terms or the Sites,
            please contact Us at{" "}
            <a href="mailto:support@hydrosat.com" className="email">
                support@hydrosat.com
            </a>
            .
        </p>
    </Typography>
);
